var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.$t('buttons.copy'),"title":_vm.$t('buttons.copy'),"id":"copy-button"},on:{"click":_vm.show}},[_c('i',{staticClass:"material-icons"},[_vm._v("content_copy")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.copyFile')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dabbb08","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Copy.vue
// module id = 368
// module chunks = 0